import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useWithdraw = (id) => useQuery({ queryKey: ['withdraw', id], queryFn: async () => {
    if(!id) return () => ({})
    const callback = await API.get(`/withdraws/${id}`)
    return callback?.data
}})

export default useWithdraw